class MegaMenu extends SimpleMegaMenu {
  constructor() {
    super();
    this.anchor = this.dataset.anchor;
    this.content = this.querySelector('.mega-menu__content');
    this.isAlreadyConnected = false;
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.isAlreadyConnected) return;
    this.isAlreadyConnected = true;

    // Use stable section IDs for all four mega-menus, independent of locale.
    // Indices match the first four entries of the Shopify main menu.
    const special = this.id.includes('mega_menu_N6Mykw')
      ? { key: 'women', index: 0, mobileIndex: 1 }
      : this.id.includes('mega_menu_DUz77J')
        ? { key: 'men', index: 1, mobileIndex: 2 }
        : this.id.includes('mega_menu_pXGUkB')
          ? { key: 'kids', index: 2, mobileIndex: 3 }
          : this.id.includes('mega_menu_Am6J6x')
            ? { key: 'accessories', index: 3, mobileIndex: 4 }
            : null;

    const targetDesktop = (special
      ? document.querySelectorAll('.header__inline-menu .list-menu--inline > li')[special.index]
      : null)
      || document.querySelector('.header__inline-menu li[data-anchor="' + this.anchor + '"]');

    const mobileDetails = special
      ? document.getElementById('Details-menu-drawer-menu-item-' + special.mobileIndex)
      : document.querySelector('header-drawer details[data-anchor="' + this.anchor + '"]');
    const targetMobile = mobileDetails &&
      mobileDetails.querySelector('.menu-drawer__inner-submenu > .menu-drawer__menu');

    // Clone before moving the desktop element (which can reconnect it).
    const contentClone = this.content && this.content.cloneNode(true);

    // Do not expose a standalone mega-menu if relocation did not succeed.
    if (!targetDesktop || !targetDesktop.firstElementChild) return;

    if (targetMobile && contentClone) {
      targetMobile.replaceWith(contentClone);
    }

    const originalTrigger = targetDesktop.firstElementChild;
    if (originalTrigger !== this) originalTrigger.replaceWith(this);
    this.classList.add('mega-menu--is-ready');
  }
}

customElements.define('mega-menu', MegaMenu);
